// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  width: 100%;
  padding: 20px;
  margin: 0 auto;
}
.wrapper .content-section {
  background: #F6F1EF;
  padding: 15px;
  border-radius: 26px;
}
.wrapper .title-wrapper {
  display: flex;
  justify-content: center;
  align-items: baseline;
  gap: 5px;
}
@media (width < 400px) {
  .wrapper .title-wrapper {
    flex-direction: column;
    align-items: start;
  }
}
.wrapper .title-wrapper .title {
  color: var(--color-black);
  font-family: AppFont, sans-serif;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 16px;
}
.wrapper .title-wrapper .title-info {
  font-family: AppFontLight;
  font-size: 10px;
  text-transform: uppercase;
}
.wrapper .header-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
.wrapper .header-block ion-icon {
  rotate: 180deg;
  transition: rotate 0.5s ease-in-out;
  z-index: 99;
  cursor: pointer;
}
.wrapper .header-block ion-icon.isOpen {
  rotate: 0deg;
}
.wrapper .filter_wrapper {
  width: 100%;
  border-radius: 26px;
  visibility: hidden;
  max-height: 0px;
  transition: opacity 0.2s ease-in-out;
  opacity: 0;
}
.wrapper .filter_wrapper.show-filters {
  visibility: visible;
  opacity: 1;
  max-height: -moz-fit-content;
  max-height: fit-content;
}
.wrapper .filter_wrapper .filter_item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding: 0px 15px;
}
.wrapper .filter_wrapper .filter_item.bottom-line {
  border-bottom: 1px solid #ebdfda;
}
.wrapper .filter_wrapper .filter_item div {
  margin-right: 10px;
}
.wrapper .filter_wrapper .filter_item p {
  font-size: 14px;
  font-family: AppFont, sans-serif;
  color: var(--color-black);
  text-transform: uppercase;
  border-radius: 26px;
}
.wrapper ion-button {
  margin-top: 10px;
  width: 100%;
}

ion-item {
  --background: transparent;
}

ion-toggle {
  --handle-background-checked: var(--primary-btn);
}`, "",{"version":3,"sources":["webpack://./src/app/components/menu-list-filters/menu-list-filters.component.scss"],"names":[],"mappings":"AAEA;EACC,WAAA;EACA,aAAA;EACA,cAAA;AADD;AAEC;EACC,mBAAA;EACA,aAAA;EACA,mBAAA;AAAF;AAGC;EACC,aAAA;EACA,uBAAA;EACM,qBAAA;EACN,QAAA;AADF;AAGQ;EANP;IAOW,sBAAA;IACA,kBAAA;EAAV;AACF;AAEE;EACC,yBAAA;EACA,gCAAA;EACA,iBAAA;EACA,yBAAA;EAEA,eAAA;AADH;AAOQ;EACI,yBAAA;EACA,eAAA;EACT,yBAAA;AALH;AAQC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AANF;AAQE;EACC,cAAA;EACA,mCAAA;EACA,WAAA;EACA,eAAA;AANH;AAOG;EACC,YAAA;AALJ;AASC;EACC,WAAA;EAGA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,oCAAA;EACA,UAAA;AATF;AAUE;EACC,mBAAA;EACA,UAAA;EACA,4BAAA;EAAA,uBAAA;AARH;AAUE;EACC,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;AARH;AASG;EACC,gCAAA;AAPJ;AASG;EACC,kBAAA;AAPJ;AASG;EACC,eAAA;EACA,gCAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;AAPJ;AAeC;EACC,gBAAA;EACA,WAAA;AAbF;;AAgBA;EACC,yBAAA;AAbD;;AAeA;EACE,+CAAA;AAZF","sourcesContent":["@import '../../../theme/mixins';\n\n.wrapper {\n\twidth: 100%;\n\tpadding: 20px;\n\tmargin: 0 auto;\n\t.content-section {\n\t\tbackground: #F6F1EF;\n\t\tpadding: 15px;\n\t\tborder-radius: 26px;\n\n\t}\n\t.title-wrapper {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n        align-items: baseline;\n\t\tgap: 5px;\n\n        @media (width < 400px) {\n            flex-direction: column;\n            align-items: start;\n        }\n\n\t\t.title {\n\t\t\tcolor: var(--color-black);\n\t\t\tfont-family: AppFont, sans-serif;\n\t\t\tfont-weight: bold;\n\t\t\ttext-transform: uppercase;\n\n\t\t\tfont-size: 16px;\n\t\t\t// @include desktop {\n\t\t\t// text-align: center;\n\t\t\t// }\n\t\t}\n\n        .title-info {\n            font-family: AppFontLight;\n            font-size: 10px;\n\t\t\ttext-transform: uppercase;\n        }\n\t}\n\t.header-block {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tcursor: pointer;\n\t\n\t\tion-icon {\n\t\t\trotate: 180deg;\n\t\t\ttransition: rotate 0.5s ease-in-out;\n\t\t\tz-index: 99;\n\t\t\tcursor: pointer;\n\t\t\t&.isOpen {\n\t\t\t\trotate: 0deg;\n\t\t\t}\n\t\t}\n\t}\n\t.filter_wrapper {\n\t\twidth: 100%;\n\n\n\t\tborder-radius: 26px;\n\t\tvisibility: hidden;\n\t\tmax-height: 0px;\n\t\ttransition: opacity 0.2s ease-in-out;\n\t\topacity: 0;\n\t\t&.show-filters {\n\t\t\tvisibility: visible;\n\t\t\topacity: 1;\n\t\t\tmax-height: fit-content;\n\t\t}\n\t\t.filter_item {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: flex-start;\n\t\t\talign-items: center;\n\t\t\twidth: 100%;\n\t\t\tpadding: 0px 15px;\n\t\t\t&.bottom-line {\n\t\t\t\tborder-bottom: 1px solid #ebdfda;\n\t\t\t}\n\t\t\tdiv {\n\t\t\t\tmargin-right: 10px;\n\t\t\t}\n\t\t\tp {\n\t\t\t\tfont-size: 14px;\n\t\t\t\tfont-family: AppFont, sans-serif;\n\t\t\t\tcolor: var(--color-black);\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tborder-radius: 26px;\n\t\t\t}\n\t\t\n\t\t\t// ion-toggle::part(handle) {\n\t\t\t// \tborder: 1px solid black;\n\t\t\t// }\n\t\t}\n\t}\n\tion-button {\n\t\tmargin-top: 10px;\n\t\twidth: 100%;\n\t}\n}\nion-item {\n\t--background: transparent;\n}\nion-toggle {\n\t --handle-background-checked: var(--primary-btn);\t\n  }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
